<template>
  <div class="wrapper-setting">
    <div class="col">
      <el-row>
        <el-col :span="5">
          <div class="bg-white min-height">
            <home-sidebar active_item="udb"></home-sidebar>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="bg-white min-height ml-3 pt-3">
            <el-form ref="form" :model="form" class="search-form" label-width="90px"
                     label-position="right">
              <el-form-item label="搜索条件">
                <el-input v-model="form.query" class="input-with-select" placeholder="姓名/手机号/车牌号">
                  <el-select v-model="form.query_field" slot="prepend" placeholder="请选择" style="width: 105px;">
                    <el-option label="姓名" value="name"></el-option>
                    <el-option label="手机" value="mobileDec"></el-option>
                    <el-option label="身份证号" value="idCardDec"></el-option>
                    <el-option label="车牌" value="carInfos.carNo"></el-option>
                  </el-select>
                </el-input>
                <el-button type="primary" @click="btn_run_query" class="ml-2">查看结果</el-button>
                <el-button @click="btn_cancel">重置选项</el-button>
              </el-form-item>

              <el-form-item label="出生地区">
                <el-select v-model="form.birthProv" placeholder="请选择省份" class="item_w" clearable
                           v-on:change="getProv($event,'birth')">
                  <el-option v-for="item in provs" :key="item.value" :label="item.label"
                             :value="item.value">
                  </el-option>
                </el-select>

                <label class="item_label pad-hidden">出生城市</label>
                <el-select v-model="form.birthCity" clearable placeholder="请选择城市" class="item_w pad-hidden">
                  <el-option v-for="item in birthCitys" :key="item.value" :label="item.label"
                             :value="item.value">
                  </el-option>
                </el-select>
                <label class="item_label">出生日期</label>
                <el-date-picker v-model="form.date_range" type="monthrange" align="left" unlink-panels
                                range-separator="——" start-placeholder="开始" end-placeholder="结束" class="item_w"
                                :picker-options="pickerOptions">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="活动地区">
                <el-select v-model="form.mobileProv" clearable placeholder="请选择" class="item_w"
                           v-on:change="getProv($event,'city')">
                  <el-option v-for="item in provs" :key="item.value" :label="item.label"
                             :value="item.value">
                  </el-option>
                </el-select>
                <label class="item_label">活动城市</label>
                <el-select v-model="form.mobileCity" clearable placeholder="请选择城市" class="item_w">
                  <el-option v-for="item in mobileCitys" :key="item.value" :label="item.label"
                             :value="item.value">
                  </el-option>
                </el-select>
                <label class="item_label pad-hidden">学历</label>
                <el-select v-model="form.degree" clearable placeholder="请选择" class="item_w pad-hidden">
                  <el-option v-for="item in degreeList" :key="item.value" :label="item.label"
                             :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="标签">
                <label class="item_label pad-hidden">电话</label>
                <el-switch class="pad-hidden" v-model="form.mobileDec"></el-switch>
                <label class="item_label">车辆</label>
                <el-switch v-model="form.hasCar"></el-switch>
                <label class="item_label">境外消费</label>
                <el-switch v-model="form.abroad"></el-switch>
                <label class="item_label pad-hidden">高档消费</label>
                <el-switch class="pad-hidden" v-model="form.isUpper"></el-switch>
                <label class="item_label">企业</label>
                <el-switch v-model="form.hasPid"></el-switch>

                <label style="width: 100px;text-align: right;padding-right:5px;">评分排序</label>
                <el-switch v-model="form.orderByCarPrice"></el-switch>
                <el-tag v-for="(tag,k) in form.tags" :key="tag" class="ml-2"
                        type="danger" closable @close="remove_tag(tag)">
                  {{ tag }}
                </el-tag>
              </el-form-item>
              <el-form-item label="评分">
                <el-input-number v-model="form.minIncome" :min="0" :max="100"
                                 style="width:120px"></el-input-number>
                <label style="width: 15px;">到</label>
                <el-input-number v-model="form.maxIncome" :min="0" :max="100"
                                 style="width:130px"></el-input-number>

                <label class="item_label">性别</label>
                <el-radio v-model="form.gender" label="male">男性</el-radio>
                <el-radio v-model="form.gender" label="female">女性</el-radio>
                <el-radio v-model="form.gender" label="">不限</el-radio>
              </el-form-item>
            </el-form>

            <div class="p-3">
              <div class="float-left mb-2">
                <el-pagination layout="total, prev, pager, next" @current-change="handleCurrentChange"
                               :page-size="this.page.size" :total="this.page.total" :current-page="this.page.index+1">
                </el-pagination>
              </div>
              <div class="float-right">
                <el-button size="small" type="danger" @click="btn_export_data">导出数据
                </el-button>
              </div>

              <el-table :data="dataList" stripe v-loading="listLoading" @selection-change="selsChange">
                <el-table-column property="name" label="姓名" width="80"></el-table-column>
                <el-table-column prop="gender" label="性别" width="50">
                  <template slot-scope="scope">
                    <span v-if="scope.row.gender == 'male'">男</span>
                    <span v-if="scope.row.gender == 'female'">女</span>
                    <span v-if="scope.row.gender == 'unknown'">未知</span>
                  </template>
                </el-table-column>
                <el-table-column property="birthDay" label="出生日期" width="110"></el-table-column>
                <el-table-column label="出生地区" width="110">
                  <template slot-scope="scope">
                    <div style="float:left">
                      {{ scope.row.birthProv }}
                    </div>
                    <div v-if="scope.row.birthCity!='null'">
                      /{{ scope.row.birthCity }}
                    </div>
                  </template>
                </el-table-column>

                <el-table-column label="OneID" width="160">
                  <template slot-scope="scope">
                    <div v-if="scope.row.mobile">
                      {{ scope.row.mobile }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="活动地区" width="110">
                  <template slot-scope="scope">
                    <div v-if="scope.row.mobileProv">
                      {{ scope.row.mobileProv }}/{{ scope.row.mobileCity }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column property="school" label="毕业学校"></el-table-column>
                <el-table-column property="degree" label="学历" width="80"></el-table-column>
                <el-table-column label="评分" width="60">
                  <template slot-scope="scope">
                    {{ scope.row.income | formatIncome }}
                  </template>
                </el-table-column>
                <el-table-column label="车辆" width="150">
                  <template slot-scope="scope">
                    <div v-for="item in scope.row.carInfos" :key="item.carNo">
                      车牌：{{ item.carNo }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column v-if="admin" label="查看" width="100">
                  <template slot-scope="scope">
                    <el-button @click="getInfoDetail(scope.row)" type="text">查看
                    </el-button>
                    <el-button v-if="scope.row.pid" @click="getCompanyList(scope.row)" type="text">企业
                    </el-button>
                  </template>
                </el-table-column>
                <el-table-column v-if="sysAdmin" label="操作" width="60">
                  <template slot-scope="scope">
                    <el-button @click="doLink(scope.row)" type="text">关联
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>

            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <export-data :dlg_export_model="dlg_export_model" :form="form" @exportClose="dlg_export_model=false"></export-data>

    <el-dialog title="关联" :visible.sync="dlg_do_link" :close-on-click-modal="false" width="500px">
      <el-form ref="pkgForm" :model="pidForm" label-width="80px">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="pidForm.name" class="item_form"></el-input>
        </el-form-item>
        <el-form-item label="UID" prop="name">
          <el-input v-model="pidForm.uid" class="item_form"></el-input>
        </el-form-item>
        <el-form-item label="pid" prop="name">
          <el-input v-model="pidForm.pid" class="item_form"></el-input>
        </el-form-item>
        <el-form-item label="hcid" prop="name">
          <el-input v-model="pidForm.hcid" class="item_form"></el-input>
        </el-form-item>
        <el-form-item label="isVip" prop="isVip">
          <el-switch v-model="pidForm.isVip"></el-switch>
        </el-form-item>
        <el-form-item label="remark" prop="remark">
          <el-input v-model="pidForm.remark" class="item_form"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="btn_do_link" type="primary">立即添加</el-button>
          <el-button @click="dlg_do_link=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog :visible.sync="dlg_slice_list" width="800px">
      <el-form>
        <el-form-item label="姓名">{{ userInfo.name }}</el-form-item>
        <template v-if="userInfo.resume">
          <el-form-item label="就读学校">{{ userInfo.resume.schools }}</el-form-item>
          <el-form-item label="最高学历">{{ userInfo.resume.degree }}</el-form-item>
          <el-form-item label="教育经历">{{ userInfo.resume.edu_list }}</el-form-item>
          <el-form-item label="公司">{{ userInfo.resume.company }}</el-form-item>
          <el-form-item label="工作经历">{{ userInfo.resume.work_list }}</el-form-item>
          <el-form-item label="职位">{{ userInfo.resume.position }}</el-form-item>
          <el-form-item label="薪资">{{ userInfo.resume.salary }}</el-form-item>
          <el-form-item label="期望行业">{{ userInfo.resume.industry }}</el-form-item>
          <el-form-item label="个人简介">{{ userInfo.resume.desc }}</el-form-item>
        </template>

        <el-form-item label="OneID">{{ userInfo.mobile }}</el-form-item>
        <el-form-item label="出生省份">{{ userInfo.birthProv }}</el-form-item>
        <el-form-item label="出生城市">{{ userInfo.birthCity }}</el-form-item>
        <el-form-item label="活动地区省份">{{ userInfo.mobileProv }}</el-form-item>
        <el-form-item label="活动地区城市">{{ userInfo.mobileCity }}</el-form-item>
        <el-form-item label="消费能力评分">{{ userInfo.income|formatIncome }}</el-form-item>
        <el-form-item label="学历">{{ userInfo.degree }}</el-form-item>
        <el-form-item v-for="item in userInfo.carInfos" :key="item.carNo">
          &nbsp;&nbsp;&nbsp;&nbsp;车牌：{{ item.carNo }}
        </el-form-item>
      </el-form>
    </el-dialog>


    <el-drawer title="相关企业列表" :visible.sync="dlg_company_list" size="600px">
      <div class="row">
        <div class="col-12">
          <div class="card-block search_list pl-3 pr-3">
            <div class="main_content">
              <el-pagination layout=" prev, pager, next" @current-change="handleHumPageChange" class="pb-3"
                             :page-size="this.humPage.size" :total="this.humPage.total"
                             :current-page="this.humPage.index+1">
              </el-pagination>
              <div v-for="(item,index) in humList" class="item">
                <el-card shadow="always" style="height:auto;">
                  <div class="content-box" style="">
                    <div v-if="item.adProv" class="content">
                      <div>地区：{{ item.adProv }}</div>
                    </div>
                    <div v-if="item.companyName" class="content">
                      <label>公司名：<span> {{ item.companyName }}</span></label>
                    </div>
                    <div v-if="item.scale" class="content">
                      <label>公司规模：<span> {{ item.scale }}</span></label>
                    </div>
                    <div class="content">
                      <label>职位：<span v-for="(i,v) in item.typeJoin">
                          {{ i.trim() }}
                        </span>
                      </label>
                    </div>
                    <div v-if="item.share" class="content">
                      <label>股份：<span> {{ item.share }}</span></label>
                    </div>
                  </div>
                </el-card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>

    <el-dialog title="详细信息" :visible.sync="dlg_detail" width="900px">
      <table class="">
        <tbody>
        <tr>
          <td rowspan="3" width="140px">{{ hum_item.name }}</td>
          <td rowspan="3" width="70%">{{ hum_item.introduction }}</td>
          <td width="80px">担任法人</td>
          <td>
            <div v-if="hum_item.legalList!=null">{{ hum_item.legalList.length }}</div>
          </td>
        </tr>
        <tr>
          <td>担任股东</td>
          <td>
            <div v-if="hum_item.holderList!=null">{{ hum_item.holderList.length }}</div>
          </td>
        </tr>
        <tr>
          <td>担任高管</td>
          <td>
            <div v-if="hum_item.officeList!=null">{{ hum_item.officeList.length }}</div>
          </td>
        </tr>
        <tr>
          <td>合作伙伴</td>
          <td colspan="3">
            <span v-for="(k,v) in hum_item.partners">{{ k.name }} </span></td>
        </tr>
        </tbody>
      </table>
    </el-dialog>
  </div>
</template>

<script>
import api from "../../api/rest"
import util from "../../api/util"
import ExportData from "../../components/ExportData.vue";
import HomeSidebar from "../../components/HomeSidebar.vue";

export default {
  name: "charts",
  components: {HomeSidebar, ExportData},
  data() {
    return {
      birthCitys: [],
      mobileCitys: [],
      sels: [],
      admin: false,
      sysAdmin: false,
      listLoading: false,
      dlg_loading: false,
      dlg_company_list: false,
      dlg_export_model: false,
      pidForm: {
        name: "",
        pid: "",
        uid: "",
      },
      folderList: [],
      select: "",
      dataList: [],
      form: {
        name: "",
        date_range: [],
        tags: [],
        mobileProv: "",
        birthProv: "",
        birthCity: "",
        mobileCity: "",
        degree: "",
        hasCar: false,
        hasPid: false,
        mobileDec: false,
        isUpper: false,
        abroad: false,
        orderByCarPrice: false,
        birthYear: "",
        birthMonth: "",
        order: "income",
        gender: "",
        query: "",
        query_field: "name",
        idx: 'udb',
      },
      page: {
        total: 0,
        index: 0,
        size: 20,
      },
      humList: [],
      humPage: {
        total: 0,
        index: 0,
        size: 20,
      },
      sltItem: {},
      provs: util.setting.getProvs(),
      pickerOptions: util.setting.getPickeAgeOpt(),
      degreeList: util.setting.getDegree(),
      indusList: util.setting.getIndustry(),
      typeList: util.setting.getEntTypeList(),
      scaleList: util.setting.getEntScaleList(),
      labels: [],
      hum_item: {},
      dlg_detail: false,
      dlg_slice_list: false,
      dlg_do_link: false,
      userInfo: ""
    };
  },
  methods: {
    getInfoDetail(row) {
      let api_url = '/search/InfoDetail'
      api.remote.doPost(row, api_url).then((res) => {
        if (res.status == "error") {
          this.userInfo = row
        } else {
          this.userInfo = res;
        }
        this.dlg_slice_list = true;
      }).catch((res) => {
        api.handError.action(this, res);
      });
    },
    btn_export_data() {
      if (api.storage.get('user') == null) {
        this.dlg_login_model = true;
      } else {
        this.form.total = this.page.total
        this.form.totalAmount = this.page.total / 100
        this.dlg_export_model = true;
      }
    },
    getCompanyList(row) {
      this.sltItem = row
      this.search_hum()
    },
    search_hum() {
      let para = {
        udb_id: this.sltItem.id,
        index: 0,
        size: 100,
      }
      let api_url = '/search/humQuery'
      api.remote.doPost(para, api_url).then((res) => {
        if (res.content.length > 0) {
          this.dlg_company_list = true
          this.humList = res.content
        } else {
          this.$message({
            title: res.title,
            message: '暂无相关数据',
            type: res.status,
          });
        }
      }).catch((res) => {
        this.listLoading = false;
        api.handError.action(this, res);
      });
    },
    remove_tag(tag) {
      const idx = this.form.tags.indexOf(tag)
      if (idx > -1) {
        this.form.tags.splice(idx, 1)
      }
      this.btn_run_query()
    },
    doLink(row) {
      this.pidForm = {}
      this.pidForm.name = row.name
      this.pidForm.uid = row.id
      let data = this.pidForm
      let api_url = '/search/get_udb_remark'
      api.remote.doPost(data, api_url).then((res) => {
        if (res != null) {
          this.pidForm = res;
        }
      })
      this.dlg_do_link = true
    },
    btn_do_link() {
      let data = {
        ...this.pidForm
      }
      let api_url = '/search/add_udb_remark'
      this.listLoading = true;
      api.remote.doPost(data, api_url).then((res) => {
        this.$message({
          title: res.title,
          message: res.message,
          type: res.status,
        });
        this.dlg_do_link = false;
        this.listLoading = false;
      }).catch((res) => {
        this.listLoading = false;
        api.handError.action(this, res);
      });
    },
    getProv: function (prov, cityType) {
      let tempCity = [];
      if (prov == '北京' || prov == '天津' || prov == '上海' || prov == '重庆') {
        if (cityType == 'birth') {
          this.birthCitys = [];
        } else {
          this.mobileCitys = [];
        }
        return
      }

      let allCity = util.setting.getCity()
      for (var val of allCity) {
        if (prov === val.prov) {
          tempCity.push({
            label: val.label,
            value: val.label
          });
        }
      }

      if (cityType == 'birth') {
        this.birthCitys = tempCity;
        this.form.birthCity = ''
      } else {
        this.mobileCitys = tempCity;
        this.form.mobileCity = ''
      }
    },
    btn_cancel(val) {
      this.form = {
        name: "",
        date_range: [],
        tags: [],
        city: "",
        degree: "",
        hasCar: false,
        hasPid: false,
        mobileDec: false,
        isUpper: false,
        abroad: false,
        orderByCarPrice: false,
        mobileProv: "",
        birthProv: "",
        birthCity: "",
        mobileCity: "",
        total: 0,
        index: 0,
        size: 50,
        ageStart: "",
        ageEnd: "",
        gender: "",
        order: "income",
        query: "",
        query_field: "name",
      };
    },
    getCity: function (city) {

    },
    search_action() {
      this.listLoading = true;
      this.page.size = this.page.size;
      let api_url = "/search/udbQuery"
      let para = {
        ...this.form,
        ...this.page
      }
      if (para.orderByCarPrice == true) {
        para.order = "maxCarPrice"
      }
      api.remote.doPost(para, api_url).then((res) => {
        if (res.status == "error") {
          this.$message({
            title: res.title,
            message: res.message,
            type: res.status
          })
        }
        this.dataList = res.content;
        this.page.total = res.totalElements
        this.listLoading = false;
      }).catch((res) => {
        this.listLoading = false;
        api.handError.action(this, res);
      });
    },
    btn_run_query(val) {
      this.page.index = 0;
      this.search_action();
    },
    handleCurrentChange(val) {
      this.page.index = val - 1;
      this.search_action();
    },
    handleHumPageChange(val) {
      this.humPage.index = val - 1;
      this.getCompanyList();
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
  },
  filters: {
    formatMobile(mobile) {
      if (mobile.length == 11) {
        let rtn = mobile.substring(0, 3) + "*****" + mobile.substring(8, 11)
        return rtn
      }
    },
    formatIncome(income) {
      return Math.ceil(income / 20) + "星"
      // return Math.floor(income * 100) / 100
      // return income.substring(0, 3)
    }
  },
  mounted() {
    // this.initData();
    var user = api.storage.get('user')
    if (user != null) {
      let roles = api.storage.get('user').roles
      if (roles.indexOf('ADMIN') != -1)
        this.admin = true
      if (roles.indexOf('SYSADMIN') != -1) {
        this.sysAdmin = true
      }
    }
    this.search_action();
  }
}
</script>




// WEBPACK FOOTER //
// Udb.vue?6107b4ca